import React, { FunctionComponent, useCallback, useRef } from "react";
import styles from "./EditIndentModal.module.scss";
import { Button } from "@mui/material";
import { SectionWidth } from "./EditIndentModal";
import TextFieldWithButtons from "../../shared/ui/TextFieldWithButtons/TextFieldWithButtons";
import ResetSection from "../../icons/ResetSection";
import Copy from "../../icons/Copy";
import Remove from "../../icons/Remove/Remove";
import { SectionInterface, StoreWallInterface } from "../../../store/types/store";
import { useShelvingStore } from "../../../store";
import { useUpdateNeighboringBrackets } from "../../../hooks/useUpdateNeighboringBrackets";
import { getInfoSections } from "../../MainMenu/Panels/DimensionsPanel/components/SectionsParamsTab/utils";
import { shelfConstants } from "../../../constants";
import { useAlerts } from "../../../hooks/useAlerts";

type PropsType = {
    activeWidth: SectionWidth;
    setActiveWidth: (width: SectionWidth) => void;
    currentSection: SectionInterface | undefined;
    closeModal: () => void;
    currentShelf: StoreWallInterface;
};

const EditIndentModalBody: FunctionComponent<PropsType> = ({
    setActiveWidth,
    activeWidth,
    currentSection,
    closeModal,
    currentShelf,
}) => {
    const { copySection, removeSection } = useShelvingStore((state) => ({
        copySection: state.copySection,
        removeSection: state.removeSection,
    }));

    const resetValues = useRef({ activeWidth });

    const infoSections = getInfoSections(currentShelf);

    const { addReadyAlert } = useAlerts();

    const resetValuesHandler = useCallback(() => {
        if (!resetValues.current.activeWidth) {
            return;
        }
        setActiveWidth(resetValues.current.activeWidth);
    }, [resetValues, setActiveWidth]);

    const updateNeighboringBrackets = useUpdateNeighboringBrackets(currentShelf.sections, currentSection);

    const copySectionHandler = () => {
        currentSection && copySection(currentSection);
        closeModal();
    };

    const removeSectionHandler = () => {
        currentSection && removeSection(currentSection);
        updateNeighboringBrackets();
        closeModal();
    };

    const setWidth = (newValue: number) => {
        let value = newValue;
        const currentSectionWidth = currentSection ? currentSection.width : 0;
        const length =
            shelfConstants.minSize.length > infoSections.length ? shelfConstants.minSize.length : infoSections.length;
        const maxLength = currentShelf.length;
        if (length + newValue - currentSectionWidth > maxLength) {
            value = maxLength + currentSectionWidth - length;
            addReadyAlert(
                `Размер отступа не может быть больше ${value}мм, т.к. суммарная ширина секций и отступа будет больше ширины стеллажа.`,
                "error",
                5000
            );
        }
        setActiveWidth(value);
    };

    return (
        <>
            <div className={styles.header}>{`Отступ шириной ${activeWidth} мм`}</div>
            <div className={styles.body}>
                <div className={styles.bodyItem}>
                    <span className={styles.title}>Ширина</span>
                    <div className={styles.content}>
                        <TextFieldWithButtons
                            isEval={true}
                            autoFocus={false}
                            min={30}
                            max={Infinity}
                            step={50}
                            objValue={activeWidth}
                            setObjValue={setWidth}
                            hotChangeValue={true}
                        />
                    </div>
                </div>
            </div>
            <div className={styles.buttons}>
                <Button className={styles.btn} variant="contained" onClick={resetValuesHandler}>
                    <span>Сброс</span>
                    <ResetSection />
                </Button>
                <Button className={styles.btn} variant="contained" onClick={copySectionHandler}>
                    <span>Копировать</span>
                    <Copy />
                </Button>
                <Button className={styles.btn} variant="contained" onClick={removeSectionHandler}>
                    <span>Удалить</span>
                    <Remove />
                </Button>
            </div>
        </>
    );
};

export default EditIndentModalBody;
